import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ComponentAction} from "../../models/component-action";
import Helpers from "../../utils/helpers";

@Injectable()
export class BotRoleBotsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getBotRoleBots(botRoleId: string): Observable<ComponentAction> {
    return this.http.get(this.baseUrl + "role/" + botRoleId + "/botrolebots") as Observable<ComponentAction>;
  }

  public createBotRoleBots(botRoleId: string, componentActions: ComponentAction) {
    Helpers.trimRecursiveObj(componentActions);
    const body = JSON.stringify(componentActions);
    return this.http.post(this.baseUrl + "role/" + botRoleId + "/botrolebots", body, {responseType: "text"});
  }

  public saveBotRoleBots(componentActions: ComponentAction) {
    Helpers.trimRecursiveObj(componentActions);
    const body = JSON.stringify(componentActions);
    return this.http.put(this.baseUrl + "/botrolebots/" + componentActions.id, body, {responseType: "text"});
  }

  public deleteBotRoleBots(botRoleBotsId: string) {
    return this.http.delete(this.baseUrl + "/botrolebots/" + botRoleBotsId, { responseType: "text" });
  }
}
